import ApproveSGBPCategoryList from "../../../features/ApproveCategoryCriteriaMapping/approveSGBPCategory/ApproveSGBPCategoryList";


const ApproveSGBPCategoryPage = () => {
  return (
    <div>
      <ApproveSGBPCategoryList />
    </div>
  );
};

export default ApproveSGBPCategoryPage;
